import type { ClickAwayListenerProps } from '@mui/material';
import MuiClickAwayListener from '@mui/material/ClickAwayListener';

export default function ClickAwayListener(props: ClickAwayListenerProps) {
  return <MuiClickAwayListener {...props} />;
}
